import { Dayjs } from 'dayjs';
import * as React from 'react';

import { DateTimeFormat } from '~config/constants';
import { ListItem } from '~features/pools/components/PoolSecondaryBlock/InfoListItem';

export function SaleStartEndItem({
  start,
  end,
}: {
  start: Dayjs | undefined;
  end: Dayjs | undefined;
}) {
  if (!start) {
    return <ListItem label="Start">TBA</ListItem>;
  }
  if (!end) {
    return (
      <ListItem label="Start">{start.format('D MMM, HH:mm a')} UTC</ListItem>
    );
  }

  const endFormat = start.day() === end.day() ? 'HH:mm a' : 'D MMM, HH:mm a';

  return (
    <ListItem label="Start/end">
      <span className="inline-block pr-1">
        {start.format('D MMM, HH:mm a')} –
      </span>
      <span className="inline-block">{end.format(endFormat)} UTC</span>
    </ListItem>
  );
}

export function SaleRegistrationStartEndItem({
  start,
  end,
}: {
  start: Dayjs | undefined;
  end: Dayjs | undefined;
}) {
  if (!start) {
    return null;
  }

  const endFormat =
    start.day() === end.day() ? DateTimeFormat.time : DateTimeFormat.noYear;

  return (
    <ListItem label="Registration">
      <span className="inline-block pr-1">
        {start.format(DateTimeFormat.noYear)} –
      </span>
      <span className="inline-block">{end.format(endFormat)}</span>
    </ListItem>
  );
}
